import addYears from "date-fns/addYears";
import startOfDay from "date-fns/startOfDay";

export const AVAILABLE_TIMESPAN = [
  {
    id: "1y",
    title: "1Y",
    since: startOfDay(addYears(new Date(), -1)).toISOString(),
  },
  {
    id: "3y",
    title: "3Y",
    since: startOfDay(addYears(new Date(), -3)).toISOString(),
  },
  {
    id: "5y",
    title: "5Y",
    since: startOfDay(addYears(new Date(), -5)).toISOString(),
  },
  {
    id: "10y",
    title: "10Y",
    since: startOfDay(addYears(new Date(), -10)).toISOString(),
  },
  {
    id: "20y",
    title: "20Y",
    since: startOfDay(addYears(new Date(), -20)).toISOString(),
  },
  { id: "all", title: "ALL", since: "1900-03-30" },
];

export const AVAILABLE_KEYS = [
  { id: "sales", title: "Sales" },
  { id: "ebitda", title: "EBITDA" },
  { id: "ebit", title: "EBIT" },
  { id: "eps", title: "EPS" },
  { id: "epsgaap", title: "EPSGAAP" },
];

export const DEFAULT_KEY = "sales";
